import { useTranslation } from "features/translations";
import { buildWidgetInstanceId } from "features/widgets";
import { WIDGETS_REGISTRY } from "features/widgets/widgets.config";
import { useMemo } from "react";
import { Container, Heading3, Heading5 } from "shared/components";
import { useCollectedData } from "shared/contexts/PageData";

import { Item } from "./Item";
import styles from "./LayoutWidget079.module.scss";

export const LayoutWidget079 = ({ payload }) => {
  const instanceId = buildWidgetInstanceId(
    "l079",
    payload.id,
    WIDGETS_REGISTRY["LAYOUT-WIDGET"]
  );
  const { t } = useTranslation();
  const { events } = useCollectedData(instanceId, [
    { name: "events", defaultValue: [] },
  ]);

  const title = payload?.title ?? "";

  const slicedItems = useMemo(() => {
    return events.slice(0, 4);
  }, [events]);

  return (
    <div className={styles.wrapper}>
      <Container>
        <div className={styles.blocks}>
          <div className={styles.top}>
            <Heading3 as="h3" className={styles.title}>
              {t(title)}
            </Heading3>
          </div>
          {events.length > 0 ? (
            <div className={styles.items}>
              {slicedItems.map((item) => (
                <Item item={item} key={item.id} />
              ))}
            </div>
          ) : (
            <Heading5 appearance="bold">{t("empty_events")}</Heading5>
          )}
        </div>
      </Container>
    </div>
  );
};

export default LayoutWidget079;
